import React, { useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import SoFormPanel from 'refactored/features/soForm/components/layout/SoFormPanel';
import SoFormRowContainer from 'refactored/features/soForm/components/layout/SoFormRowContainer';
import SoFormPanelText from 'refactored/features/soForm/components/layout/SoFormPanelText';
import {
  GirdedQuestionIcon,
  ReferenceIcon,
  InstructionsIcon,
} from 'refactored/ui/icons';
import SoFormCollapsableInput from './SoFormCollapsableInput';
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
import { useSelector } from 'react-redux';
import { selectors as shipmentsSelectors } from 'state/shipments';
import Tooltip from 'components/Tooltip';
import SoSpecialIntructionsTooltip from '../complements/SoSpecialIntructionsTooltip';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

const TextInput = styled.input`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 12px 12px 16px;
  gap: 12px;

  width: 100%;
  height: 48px;

  /* secondary / white */

  background: #ffffff;
  /* grey / 300 */

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 900 */
  color: #263340;

  &::placeholder {
    /* grey / 500 */
    color: #94a6b8;
  }
  outline: none;
`;

const TextareaInput = styled.textarea`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 12px 12px 16px;
  gap: 12px;

  width: 100%;

  /* secondary / white */

  background: #ffffff;
  /* grey / 300 */

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 900 */
  color: #263340;

  &::placeholder {
    /* grey / 500 */
    color: #94a6b8;
  }
  outline: none;
  resize: none;
  /* height: auto; */
  min-height: 49px;
  /* max-height: 500px; */
  /* border: 5px solid red; */
`;

const StopInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  /* width: 540px; */
  height: 44px;
`;

const StopInfoTypeText = styled.div`
  height: 24px;

  /* 16px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 700 */

  color: #54708c;
`;

const StopInfoCompanyText = styled.div`
  height: 16px;

  /* 14px/regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* grey / 700 */

  color: #54708c;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: var(--grey300);
  margin: 10px 0px;
`;

const useAutosizeTextArea = (textAreaRef, value, max) => {
  useEffect(() => {
    if (textAreaRef) {
      // We need to reset the height momentarily to get the correct scrollHeight for the textarea
      textAreaRef.style.height = '0px';
      const scrollHeight = textAreaRef.scrollHeight;

      // We then set the height directly, outside of the render loop
      // Trying to set this with state or a ref will product an incorrect value.
      if (scrollHeight <= max) {
        textAreaRef.style.height = scrollHeight + 'px';
      } else {
        textAreaRef.style.height = max + 'px';
      }
    }
  }, [max, textAreaRef, value]);
};

const SoFormComplementInfo = ({ className }) => {
  const { t } = useTranslation('Catalog');

  // state
  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  const redux_address_from = useSelector((state) =>
    shipmentsSelectors.getShipmentAddress(state, 'FIRST_SHIPMENT', 'pickup')
  );
  const redux_address_to = useSelector((state) =>
    shipmentsSelectors.getShipmentAddress(state, 'FIRST_SHIPMENT', 'dropoff')
  );

  const { add_internal_reference, internal_reference } = stepsState.complements;
  const {
    add_comment,
    pickup_comment_from_shipper_to_driver,
    dropoff_comment_from_shipper_to_driver,
  } = stepsState.complements;

  const textAreaPickupRef = useRef(null);
  const textAreaDropoffRef = useRef(null);

  useAutosizeTextArea(
    textAreaPickupRef.current,
    pickup_comment_from_shipper_to_driver,
    140
  );

  useAutosizeTextArea(
    textAreaDropoffRef.current,
    dropoff_comment_from_shipper_to_driver,
    140
  );

  return (
    <div className={className}>
      <SoFormPanel>
        <SoFormRowContainer>
          <SoFormPanelText>
            {t('complements.complementary_info')}
          </SoFormPanelText>
          <Tooltip
            className="title-tooltip"
            component={<SoSpecialIntructionsTooltip />}
            segmentTitle="form complements_instructions_reference"
          >
            <GirdedQuestionIcon />
          </Tooltip>
        </SoFormRowContainer>
        <TempContainer>
          <SoFormCollapsableInput
            isSelected={add_internal_reference}
            setIsSelected={stepsApi.setAddInternalReference}
            icon={<ReferenceIcon />}
            label={t('complements.add_internal_reference_to_shipment')}
          >
            <TextInput
              onChange={(e) => {
                const value = e.target.value;
                stepsApi.setInternalReference(value);
              }}
              value={internal_reference}
              placeholder={t('complements.add_reference')}
            />
          </SoFormCollapsableInput>
          <SoFormCollapsableInput
            isSelected={add_comment}
            setIsSelected={stepsApi.setAddComment}
            icon={<InstructionsIcon />}
            label={t('complements.add_instructions_for_driver')}
          >
            <StopInfoContainer>
              <StopInfoTypeText>{t('complements.in_pickup')}</StopInfoTypeText>
              <StopInfoCompanyText>
                {redux_address_from.company_name}
              </StopInfoCompanyText>
            </StopInfoContainer>
            <TextareaInput
              ref={textAreaPickupRef}
              rows={1}
              onChange={(e) => {
                const value = e.target.value;
                stepsApi.setComment(value, 'pickup');
              }}
              value={pickup_comment_from_shipper_to_driver}
              placeholder={t('complements.add_instructions_for_driver')}
            />
            <Separator />
            <StopInfoContainer>
              <StopInfoTypeText>{t('complements.in_dropoff')}</StopInfoTypeText>
              <StopInfoCompanyText>
                {redux_address_to.company_name}
              </StopInfoCompanyText>
            </StopInfoContainer>
            <TextareaInput
              ref={textAreaDropoffRef}
              rows={1}
              onChange={(e) => {
                const value = e.target.value;
                stepsApi.setComment(value, 'dropoff');
              }}
              value={dropoff_comment_from_shipper_to_driver}
              placeholder={t('complements.add_instructions_for_driver')}
            />
          </SoFormCollapsableInput>
        </TempContainer>
      </SoFormPanel>
    </div>
  );
};

SoFormComplementInfo.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export default styled(SoFormComplementInfo)`
  ${regularCSS}
`;
